function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep5TeaserIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 383.4",
    style: {
      enableBackground: "new 0 0 384 383.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M227.9,35.7L192.2,0l-67.9,67.9V29.8H45.8v116.6L0,192.2l15.9,15.9l17.4-17.4v170.2H0.4v22.5H384 v-22.5h-32.8V190.7l16.8,16.8l15.9-15.9l-35.4-35.4L227.9,35.7z M68.3,52.2h33.5v38.2l-33.5,33.5V52.2z M99.2,360.9V313h186v47.9 H99.2z M154.1,230.3c-6.6,0-12-5.4-12-12c0-6.6,5.4-12,12-12c6.6,0,12,5.4,12,12C166.1,224.9,160.7,230.3,154.1,230.3L154.1,230.3z  M154.1,252.8c19.3,0,35,15.7,35,35v2.8h-70v-2.8C119.1,268.5,134.8,252.8,154.1,252.8L154.1,252.8z M266,290.6h-53.8v-24.2H266 V290.6z M327.9,167.4l0.8,0.8v192.6h-21v-70.3h-19.2v-46.7h-97.4c-2.7-2.3-5.6-4.3-8.6-6c3.8-5.6,6.1-12.3,6.1-19.6 c0-19-15.5-34.5-34.5-34.5c-19,0-34.5,15.5-34.5,34.5c0,7.3,2.3,14,6.1,19.6c-17.4,9.9-29.1,28.6-29.1,49.9v2.8H76.8v70.3h-21V168.3 L192.2,31.8l24.5,24.5L327.9,167.4z M288.5,290.6"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5TeaserIcon1);
export default __webpack_public_path__ + "static/media/step-5-teaser-icon-1.2cbee31509741dfad1f7e701d4a355ab.svg";
export { ForwardRef as ReactComponent };